import React from 'react';

const BingAdsIcon: React.FC = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.013 4.013l7.98 3.591-5.717 12.383L4.013 4.013zm9.98 3.591L20 4v16l-8.28-4.731 2.273-7.666z" />
  </svg>
);

export default BingAdsIcon;